/**
 * 验收标准确认书 workflow status stepper + event trail. The stepper shows the main path; return /
 * revision loops surface as the current-status pill and in the event list (with comments), not extra steps.
 */
import { WF_STATUS, WF_STEPS, type WorkflowEvent, type WorkflowStatus } from '../lib/api';

const STEP_LABEL: Record<string, string> = {
  pm_drafting: 'PM 拟定', submitted: '估价审核', released: '劳务答疑',
  labor_clear: '确认清楚', annexure_review: '验收标准确认', finalized: '定稿',
};

/** Index of the furthest main-path step this status implies. */
function stepIndex(status: WorkflowStatus): number {
  if (status === 'returned') return WF_STEPS.indexOf('pm_drafting');
  if (status === 'revision_requested') return WF_STEPS.indexOf('annexure_review');
  return WF_STEPS.indexOf(status);
}

export default function WorkflowTimeline({ status, events }: { status: WorkflowStatus; events?: WorkflowEvent[] }) {
  const cur = stepIndex(status);
  const st = WF_STATUS[status];
  return (
    <div style={{ marginBottom: 10 }}>
      <div className="row-wrap" style={{ gap: 4, alignItems: 'center', marginBottom: 6 }}>
        {WF_STEPS.map((s, i) => (
          <span key={s} className="row" style={{ gap: 4, alignItems: 'center' }}>
            {i > 0 && <span className="muted small">→</span>}
            <span
              className={`pill small ${i < cur ? 'pill-good' : i === cur ? (st?.pill ?? 'pill-stage') : 'pill-muted'}`}
              style={i > cur ? { opacity: 0.5 } : undefined}
            >
              {i < cur ? '✓ ' : ''}{STEP_LABEL[s]}
            </span>
          </span>
        ))}
        {(status === 'returned' || status === 'revision_requested') && st && (
          <span className={`pill small ${st.pill}`}>{st.label}</span>
        )}
      </div>
      {events && events.length > 0 && (
        <details className="small">
          <summary className="muted" style={{ cursor: 'pointer' }}>流转记录 / history（{events.length}）</summary>
          <ul style={{ margin: '4px 0 0', paddingLeft: 18 }}>
            {events.map((e, i) => (
              <li key={i} style={{ marginBottom: 2 }}>
                <span className="muted">{e.created_at.slice(0, 16).replace('T', ' ')}</span>{' '}
                {e.actor_name ?? e.actor_type} · {WF_STATUS[e.to_status as WorkflowStatus]?.label ?? e.to_status}
                {e.comment_md && <span> — “{e.comment_md}”</span>}
              </li>
            ))}
          </ul>
        </details>
      )}
    </div>
  );
}
